import { CloseIcon } from "../../../assets/svgIcons";
import Button from "../Button/Button";

export const ModalCloseBtn = ({
  onClick = () => {},
  text = "Close",
  IconColor = "black",
}) => {
  return (
    <Button type="button" classNames={"btn btn--outline"} onClick={onClick}>
      <CloseIcon
        className="mr-1"
        style={{ fontSize: "25px", color: IconColor }}
      />
      {text}
    </Button>
  );
};
